// extracted by mini-css-extract-plugin
export var subtitle = "styles-module--subtitle--d6ee3";
export var title = "styles-module--title--9b0ff";
export var wrapper = "styles-module--wrapper--46d8d";